import { buildRequestsFilter } from '@/modules/service-requests/shared/application-api';
import {
  dateOnlyFromClause,
  dateOnlyToClause,
} from '@/modules/service-requests/shared/application-utils';
import { RequestFilters } from '@/modules/service-requests/shared/service-desk.types';

export interface NocTravelRange {
  /** `<input type="date">` values; empty when unset. */
  from: string;
  to: string;
}

/**
 * Legacy `BuildNocQuery`: name keyword and department, plus a travel window -- applications
 * whose travel starts on/after `from` and ends on/before `to`.
 */
export const buildNocFilter = (
  filters: RequestFilters,
  travel: NocTravelRange,
  departmentCondition: string | { $in: string[] } | undefined
) => {
  // Travel dates are date-only (00:00:00 UTC of the day), so the bounds are UTC midnights.
  const from = dateOnlyFromClause(travel.from);
  const to = dateOnlyToClause(travel.to);
  return buildRequestsFilter(filters, 'Name', departmentCondition, {
    ...(from ? { TravelStartDate: from } : {}),
    ...(to ? { TravelEndDate: to } : {}),
  });
};
